module.exports = __webpack_public_path__ + "static/media/osborne stadium.7464afbb.jpeg";